import * as z from "zod";

export const flagReturn = {
  name: "flagReturn" as const,
  input: z.object({ returnId: z.string(), flagged: z.boolean() }),
  output: z.object({ success: z.boolean() }),
};
